import * as moment from "moment";

import * as actions from "./actiontypes";
import { EmployeeRecordAction } from "./actions";
import { EmployeeRecordInRedux, EmployeeRecordsDetail, EmployeeRecordDetailModel } from "./model";

export function employeeRecordsDetail(state: EmployeeRecordsDetail = { employeeRecords: [], tooManyRecords: false },
    action: EmployeeRecordAction): EmployeeRecordsDetail {
    switch (action.type) {
        case actions.LOAD_EMPLOYEERECORDS_SUCCESS:
            return { employeeRecords: employeeRecords(state.employeeRecords, action), tooManyRecords: action.payload.tooManyRecords };
        default:
            return { employeeRecords: employeeRecords(state.employeeRecords, action), tooManyRecords: state.tooManyRecords };
    }
}

export function employeeRecords(state: EmployeeRecordInRedux[] = [], action: EmployeeRecordAction): EmployeeRecordInRedux[] {
    switch (action.type) {
        case actions.LOAD_EMPLOYEERECORDS_SUCCESS:
            return action.payload.employeeRecords.map(c => ({ ...(state.find(s => s.id === c.id) || {}), ...c, listUpdated: moment() }));
        case actions.SAVE_EMPLOYEERECORD_SUCCESS:
        case actions.LOAD_EMPLOYEERECORD_DETAIL_SUCCESS:
            if (!state.find(c => c.id === (action.payload.id))) {
                return [...state, employeeRecord({
                    id: action.payload.id,
                    customerId: action.payload.customerId
                }, action)];
            }
            return state.map(c => employeeRecord(c, action));
        case actions.CREATE_EMPLOYEE_DOCUMENT_SUCCESS:
        case actions.LOAD_EMPLOYEE_DOCUMENTS_SUCCESS:
        case actions.DELETE_EMPLOYEE_DOCUMENT_SUCCESS:
        case actions.SET_CLOSE_MONITORING_SUCCESS:
            if (!state.find(c => c.id === action.payload.employeeRecordId)) {
                return [...state, employeeRecord({
                    id: action.payload.employeeRecordId,
                    customerId: action.payload.customerId
                }, action)];
            }
            return state.map(c => employeeRecord(c, action));
        case actions.CREATE_EMPLOYEERECORD_SUCCESS:
            return [...state, detailUpdated(action.payload)];
        case actions.DELETE_EMPLOYEERECORD_SUCCESS:
            return [...state.filter(c => c.id !== action.payload)];
        case actions.ACTIVATE_EMPLOYEERECORD_SUCCESS:
            const activatedEmployeeRecord = state.find(employee => employee.id === action.payload);
            return [...state.filter(c => c.id !== action.payload), { ...activatedEmployeeRecord, active: true }];
        case actions.DEACTIVATE_EMPLOYEERECORD_SUCCESS:
            const deactivatedEmployeeRecord = state.find(employee => employee.id === action.payload);
            return [...state.filter(c => c.id !== action.payload), { ...deactivatedEmployeeRecord, active: false }];
        default:
            return state;
    }
}

function employeeRecord(state: EmployeeRecordInRedux, action: EmployeeRecordAction): EmployeeRecordInRedux {
    switch (action.type) {
        case actions.SAVE_EMPLOYEERECORD_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case actions.LOAD_EMPLOYEERECORD_DETAIL_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case actions.CREATE_EMPLOYEE_DOCUMENT_SUCCESS:
            if (action.payload.employeeRecordId === state.id) {
                return {
                    ...state,
                    documents: [
                        ...("documents" in state ? state.documents : []),
                        action.payload.document
                    ]
                };
            }
            return state;
        case actions.LOAD_EMPLOYEE_DOCUMENTS_SUCCESS:
            if (action.payload.employeeRecordId === state.id) {
                return { ...state, documents: action.payload.documents };
            }
            return state;
        case actions.DELETE_EMPLOYEE_DOCUMENT_SUCCESS:
            if (action.payload.employeeRecordId === state.id && "documents" in state) {
                return { ...state, documents: state.documents.filter(d => d.id !== action.payload.employeeDocumentId) };
            }
            return state;
        case actions.SET_CLOSE_MONITORING_SUCCESS:
            if (action.payload.employeeRecordId === state.id) {
                return { ...state, closeMonitoring: action.payload.closeMonitoring };
            }
            return state;
        default:
            return state;
    }
}

function detailUpdated(value: EmployeeRecordDetailModel, state: EmployeeRecordInRedux = {} as EmployeeRecordInRedux): EmployeeRecordInRedux {
    return { listUpdated: moment(), ...state, ...value, detailUpdated: moment() };
}
